export default __webpack_public_path__ + "static/media/IX_Old_Black.170fc901.png";